let localURL = "https://codebase-backend-production.up.railway.app/";
// let localURL = "https://redimit.herokuapp.com/";
// let prodURL = "https://api.redimit.com/";
/*  */
export let baseUrl = process.env.NODE_ENV === "production" ? localURL : localURL;
// export let baseUrl = process.env.NODE_ENV === "production" ? prodURL : localURL;

// export let baseUrl = process.env.REACT_APP_BACKEND_URL;

/** USER */

//Get All Banks
export let getBank = baseUrl + "data/banks";

// Coin converter
// export let converterApi = baseUrl + "data/coinsdata/?coin=BTC&currency=USD";
export let converterApi = function (select) {
	// return baseUrl + `data/coinvalue?coin=${select}&currency=USD`;
	return baseUrl + `data/coins/value-to-dollar?coinType=${select}&coinValue=1`;
};

// Fetch Images
export let fetchImage = function (list) {
	return baseUrl + `data/coinsvalue?coins=${list}`;
};

// Fetch coins
export let fetchCoinsUrl = function (coin) {
	if(coin){
		return baseUrl + `coins/${coin}`;
	}
	else{
		return baseUrl + `coins`;
	}
};

// Get Account Details
export let getAccountInfo = function (acctNum, bankCode) {
	return baseUrl + `data/banks/resolve?accountNumber=${acctNum}&bankCode=${bankCode}`;
};
// Create transaction

export let create = baseUrl + "transactions";

// Create Bitcoin transaction
export let btcCreate = baseUrl + "bitcoin/sell";

// Create Multiple Bitcoin transaction
export let btcCreateMultiple = baseUrl + "bitcoin/multiple/sell";

// Create Ethereum Transaction
export let ethCreate = baseUrl + "wallet/eth";

// Create USDT Transaction
export let usdtCreate = baseUrl + "wallet/usdt";

// Transaction summary
export let transSummary = function (ref) {
	return baseUrl + `transactions/${ref}`;
};

// Complete with Hash and Phone number
export let transComplete = function (ref) {
	return baseUrl + `transactions/complete/${ref}`;
};






/*******************
 *  
 * USER AUTHETICATION 
 * AND
 * ACCOUNT CALLS
 *  
 *********************/


export let auth = function (otherRoute) {
	if(otherRoute){
		return baseUrl + `auth/${otherRoute}`;
	}
	else{
		return baseUrl + `auth`;
	}
};

export let fetchAllCoins = function (coin) {
	if(coin){
		return baseUrl + `coins/${coin}`;
	}
	else{
		return baseUrl + `coins`;
	}
};

export let transaction = function (coin) {
	if(coin){
		return baseUrl + `transactions/${coin}`;
	}
	else{
		return baseUrl + `transactions`;
	}
};